/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_Copy_ErrorInputs */

const en_road_dude_prompt_copy_error = /** @type {(inputs: Road_Dude_Prompt_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clipboard unavailable. Select and copy the prompt from the text box.`)
};

const zh_road_dude_prompt_copy_error = /** @type {(inputs: Road_Dude_Prompt_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剪贴板不可用，请选中文本框中的提示词后复制。`)
};

/**
* | output |
* | --- |
* | "Clipboard unavailable. Select and copy the prompt from the text box." |
*
* @param {Road_Dude_Prompt_Copy_ErrorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_copy_error = /** @type {((inputs?: Road_Dude_Prompt_Copy_ErrorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_Copy_ErrorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_copy_error(inputs)
	return zh_road_dude_prompt_copy_error(inputs)
});
export { road_dude_prompt_copy_error as "road_dude.prompt.copy_error" }